"use strict";

module.exports = validate;
var _require = require("@octokit/request-error"),
  RequestError = _require.RequestError;
var get = require("lodash.get");
var set = require("lodash.set");
function validate(octokit, options) {
  if (!options.request.validate) {
    return;
  }
  var params = options.request.validate;
  Object.keys(params).forEach(function (parameterName) {
    var parameter = get(params, parameterName);
    var expectedType = parameter.type;
    var parentParameterName;
    var parentValue;
    var parentParamIsPresent = true;
    var parentParameterIsArray = false;
    if (/\./.test(parameterName)) {
      parentParameterName = parameterName.replace(/\.[^.]+$/, "");
      parentParameterIsArray = parentParameterName.slice(-2) === "[]";
      if (parentParameterIsArray) {
        parentParameterName = parentParameterName.slice(0, -2);
      }
      parentValue = get(options, parentParameterName);
      parentParamIsPresent = parentParameterName === "headers" || typeof parentValue === "object" && parentValue !== null;
    }
    var values = parentParameterIsArray ? (get(options, parentParameterName) || []).map(function (value) {
      return value[parameterName.split(/\./).pop()];
    }) : [get(options, parameterName)];
    values.forEach(function (value, i) {
      var valueIsPresent = typeof value !== "undefined";
      var valueIsNull = value === null;
      var currentParameterName = parentParameterIsArray ? parameterName.replace(/\[\]/, "[".concat(i, "]")) : parameterName;
      if (!parameter.required && !valueIsPresent) {
        return;
      }

      // if the parent parameter is of type object but allows null
      // then the child parameters can be ignored
      if (!parentParamIsPresent) {
        return;
      }
      if (parameter.allowNull && valueIsNull) {
        return;
      }
      if (!parameter.allowNull && valueIsNull) {
        throw new RequestError("'".concat(currentParameterName, "' cannot be null"), 400, {
          request: options
        });
      }
      if (parameter.required && !valueIsPresent) {
        throw new RequestError("Empty value for parameter '".concat(currentParameterName, "': ").concat(JSON.stringify(value)), 400, {
          request: options
        });
      }

      // parse to integer before checking for enum
      // so that string "1" will match enum with number 1
      if (expectedType === "integer") {
        var unparsedValue = value;
        value = parseInt(value, 10);
        if (isNaN(value)) {
          throw new RequestError("Invalid value for parameter '".concat(currentParameterName, "': ").concat(JSON.stringify(unparsedValue), " is NaN"), 400, {
            request: options
          });
        }
      }
      if (parameter.enum && parameter.enum.indexOf(String(value)) === -1) {
        throw new RequestError("Invalid value for parameter '".concat(currentParameterName, "': ").concat(JSON.stringify(value)), 400, {
          request: options
        });
      }
      if (parameter.validation) {
        var regex = new RegExp(parameter.validation);
        if (!regex.test(value)) {
          throw new RequestError("Invalid value for parameter '".concat(currentParameterName, "': ").concat(JSON.stringify(value)), 400, {
            request: options
          });
        }
      }
      if (expectedType === "object" && typeof value === "string") {
        try {
          value = JSON.parse(value);
        } catch (exception) {
          throw new RequestError("JSON parse error of value for parameter '".concat(currentParameterName, "': ").concat(JSON.stringify(value)), 400, {
            request: options
          });
        }
      }
      set(options, parameter.mapTo || currentParameterName, value);
    });
  });
  return options;
}